import { useCallback } from 'react';
import { useQueryParams } from 'use-query-params';
import { DecodedValueMap, QueryParamConfigMap } from 'serialize-query-params';
import { UrlUpdateType } from 'use-query-params/lib/types';

/**
 * Wrapper around `useQueryParams` that defaults to `'pushIn'`, so user-initiated param changes are
 * back-navigable. Pass `'replaceIn'` explicitly for programmatic/initialization updates.
 */
export const useQueryParamsWithHistory = <QPCMap extends QueryParamConfigMap>(
  paramConfigMap: QPCMap,
): [DecodedValueMap<QPCMap>, (changes: Partial<DecodedValueMap<QPCMap>>, updateType?: UrlUpdateType) => void] => {
  const [queryParams, setQueryParams] = useQueryParams(paramConfigMap);

  const setWithHistory = useCallback(
    (changes: Partial<DecodedValueMap<QPCMap>>, updateType: UrlUpdateType = 'pushIn') => {
      setQueryParams(changes, updateType);
    },
    [setQueryParams],
  );

  return [queryParams, setWithHistory];
};
